import { inject, Injectable } from '@angular/core';
import { PnycPopupService } from '@ui-kit/popup/pnyc-popup.service';

@Injectable({ providedIn: 'root' })
export class FeatureFlagsPopupService {
    private readonly popupService = inject(PnycPopupService);

    open(): void {
        void import('../components/feature-flags-dialog/feature-flags-dialog.component')
            .then(({ FeatureFlagsDialogComponent }) => {
                this.popupService.openDialog(FeatureFlagsDialogComponent, null, {
                    customClass: 'feature-flags-modal',
                });
            });
    }
}
